import styled from 'styled-components';

const Banner = styled.div`
  padding: ${({ theme }) => `${theme.spacing(2.5)} ${theme.spacing(3)}`};
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => `${theme.colors.status.warning}55`};
  background: ${({ theme }) => `${theme.colors.status.warning}14`};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;
  line-height: 1.45;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const Title = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.status.warning};
`;

interface ParseWarningsBannerProps {
  warnings?: string[] | null;
}

export function ParseWarningsBanner({ warnings }: ParseWarningsBannerProps) {
  if (!warnings || warnings.length === 0) return null;
  return (
    <Banner role="status">
      <Title>Предупреждение при чтении Excel</Title>
      {warnings.map((w, idx) => (
        <div key={idx}>{w}</div>
      ))}
    </Banner>
  );
}
